/**
 * Theme Provider
 */

'use client';

import { createContext, useContext, ReactNode } from 'react';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import type { Theme as EmotionTheme } from '@emotion/react';
import { Theme } from './types';
import { defaultTheme } from './defaultTheme';
import {
  buildCustomizationStyleBlocks,
  type FunnelOverviewCustomization,
} from '../customization';

const ThemeContext = createContext<Theme>(defaultTheme);

export interface ThemeProviderProps {
  theme?: Theme;
  customization?: FunnelOverviewCustomization;
  children: ReactNode;
}

export function ThemeProvider({ theme = defaultTheme, customization, children }: ThemeProviderProps) {
  const styleBlocks = buildCustomizationStyleBlocks(customization);

  return (
    <ThemeContext.Provider value={theme}>
      <EmotionThemeProvider theme={theme as unknown as EmotionTheme}>
        {styleBlocks.map((block) => (
          <style
            key={block.slotId}
            data-funnel-overview-slot={block.slotId}
            dangerouslySetInnerHTML={{ __html: block.css }}
          />
        ))}
        {children}
      </EmotionThemeProvider>
    </ThemeContext.Provider>
  );
}

export function useTheme(): Theme {
  return useContext(ThemeContext);
}
